export default __webpack_public_path__ + "static/media/TL07.381badb0.mp3";